import React, { useState } from "react";
import { Box, IconButton, Collapse, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import dayjs from 'dayjs';
import 'dayjs/locale/en-gb'; // Import the locale for British English

const MessageCollapse = ({ row }) => {
  const [open, setOpen] = useState(false);

  const toggleOpen = () => setOpen(!open);

  return (
    <Box>
      <IconButton  onClick={toggleOpen}>
        <ExpandMoreIcon />
      </IconButton>
      <Collapse in={open}>
        {row.values.Message.map((msg, index) => (
          <Box key={index} sx={{ marginTop: 2 }}>
          <TableContainer
            sx={{
              boxShadow: 'none',
              width: '100%',
              overflowX: 'auto', // Enable horizontal scrolling for smaller screens
              maxWidth: '100%', // Prevent the table from going beyond the screen width
            }}
          >
            <Table sx={{ minWidth: '650px', display: 'block' }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '12px', sm: '14px', md: '16px' }, // Responsive font size
                    }}
                  >
                    {/* IdRequest */}
                    Richiesta ID
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '12px', sm: '14px', md: '16px' }, // Responsive font size
                    }}
                  >
                    {/* Title */}
                    Titolo
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '12px', sm: '14px', md: '16px' }, // Responsive font size
                    }}
                  >
                    {/* Description */}
                    Descrizione
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '12px', sm: '14px', md: '16px' }, // Responsive font size
                    }}
                  >
                    {/* Company Name */}
                    Nome dell'azienda
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '12px', sm: '14px', md: '16px' }, // Responsive font size
                    }}
                  >
                    {/* Category */}
                    Categoria
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '12px', sm: '14px', md: '16px' }, // Responsive font size
                    }}
                  >
                    {/* Type */}
                    Tipo
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '12px', sm: '14px', md: '16px' }, // Responsive font size
                    }}
                  >
                    {/* Publish Date */}
                    Data di pubblicazione
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '10px', sm: '12px', md: '14px' }, // Responsive font size for body cells
                    }}
                  >
                    {msg.IdRequest}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '10px', sm: '12px', md: '14px' }, // Responsive font size for body cells
                    }}
                  >
                    {msg.Title}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '10px', sm: '12px', md: '14px' }, // Responsive font size for body cells
                    }}
                  >
                    {msg.Description}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '10px', sm: '12px', md: '14px' }, // Responsive font size for body cells
                    }}
                  >
                    {msg.companyName}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '10px', sm: '12px', md: '14px' }, // Responsive font size for body cells
                    }}
                  >
                    {msg.CategoryName}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '10px', sm: '12px', md: '14px' }, // Responsive font size for body cells
                    }}
                  >
                    {msg.TypeName}
                  </TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'center',
                      width: '150px',
                      fontSize: { xs: '10px', sm: '12px', md: '14px' }, // Responsive font size for body cells
                    }}
                  >
                    
                    {msg.PublishDate ? dayjs(msg.PublishDate).format('DD-MM-YYYY') : ''}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        ))}
      </Collapse>
    </Box>
  );
};

export default MessageCollapse;